import { render, staticRenderFns } from "./CardsInfoEntradas.vue?vue&type=template&id=5ecf03cc"
import script from "./CardsInfoEntradas.vue?vue&type=script&setup=true&lang=js"
export * from "./CardsInfoEntradas.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports